import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityAttributeTemplateComponent } from '../entity-attribute-template/entity-attribute-template.component';


@Component({
    selector: 'entity-attribute-test',
    templateUrl: './entity-attribute-test.component.html',
    styleUrls: ['./entity-attribute-test.component.scss'],
    standalone: false
})
export class EntityAttributeTestComponent implements EntityAttributeTemplateComponent, OnInit {

  attributeFormGroup: UntypedFormGroup;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,

  ) {

  }

  ngOnInit() {
    this.attributeFormGroup = this._formBuilder.group({

    });
    this.attributeFormGroup.addControl('attribute1', new UntypedFormControl('', [Validators.required]));
    this.attributeFormGroup.addControl('attribute2', new UntypedFormControl('', [Validators.required]));
  }

  processObject(obj) {
    return obj;
  }

  validateForm() {

  }

  isValid() {
    return this.attributeFormGroup.valid;
  }
}

